
export const constants = {
    bgColor: ['#E6E7EB', '#B270EC', '#612E86', '#EBD0FD'],
    themeColor: "#612E86",
    // themeColor: "#004C92",
    // bgColor: ['#E6E7EB', '#004C92', '#6aa8dd', '#3e84c0']
};